import { Controller } from "@hotwired/stimulus";
import { t } from "../i18n";

// Connects to data-controller="checkout"
export default class extends Controller {
  static values = {
    totalAmount: Number,
    discountAmount: Number,
    intlDeliveryFee: Number,
    localCountryId: Number,
  };
  static targets = [
    "total",
    "subtotal",
    "deliveryFee",
    "shippingFields",
    "shippingAddressDifferentToBillingRadio",
    "shippingCountry",
    "billingCountry",
  ];

  connect() {
    // console.log(this.setAmounts());
    console.log(this.billingCountryTarget);
  }

  setShippingFieldVisibility(e) {
    if (e.target.value == "true") {
      this.shippingFieldsTarget.classList.add("hidden");
    } else {
      this.shippingFieldsTarget.classList.remove("hidden");
    }
  }

  setAmounts() {
    // Start with subtotal minus discount
    let amount = this.totalAmountValue - this.discountAmountValue;

    if (
      (this.shippingAddressDifferentToBillingRadioTarget.checked &&
        parseInt(this.shippingCountryTarget.value, 10) !==
          this.localCountryIdValue) ||
      (!this.shippingAddressDifferentToBillingRadioTarget.checked &&
        parseInt(this.billingCountryTarget.value, 10) !==
          this.localCountryIdValue)
    ) {
      amount += this.intlDeliveryFeeValue;
      this.deliveryFeeTarget.innerHTML = `$${(this.intlDeliveryFeeValue / 100).toFixed(2)}`;
    } else {
      this.deliveryFeeTarget.innerHTML = t("js.checkout.free");
    }

    this.totalTarget.innerHTML = `$${(amount / 100).toFixed(2)}`;
  }
}
